import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import anatel from "../assets/anatel.png";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const isRoutedPage = !["/", "/home"].includes(location.pathname);

  const jumpTo = (section) => {
    if (isRoutedPage) {
      navigate("/", { state: { scrollTo: section } });
    } else {
      scroller.scrollTo(section, {
        duration: 500,
        smooth: true,
        offset: -70,
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <h2 id="vitalink-footer-heading" className="visually-hidden">
          Informações do rodapé VitaLink
        </h2>

        <div className="footer__grid">
          <section className="footer__group footer__brand">
            <button
              className="footer__logo"
              onClick={() => jumpTo("home")}
              aria-label="Voltar ao início"
            >
              VitaLink
            </button>
            <p className="footer__text">
              Internet de fibra óptica pura com alta velocidade, estabilidade e
              suporte local em Conselheiro Lafaiete.
            </p>
          </section>

          <nav className="footer__group" aria-label="Páginas do site">
            <h3 className="footer__title">Páginas</h3>
            <ul className="footer__list">
              <li><button className="footer__link" onClick={() => jumpTo("home")}>Home</button></li>
              <li><button className="footer__link" onClick={() => jumpTo("about")}>Quem somos</button></li>
              <li><button className="footer__link" onClick={() => jumpTo("plans")}>Planos</button></li>
              <li><a href="https://www.speedtest.net/pt" target="_blank" rel="noopener noreferrer" className="footer__link">Teste de velocidade</a></li>
              <li><button className="footer__link" onClick={() => jumpTo("faq")}>Dúvidas</button></li>
            </ul>
          </nav>

          <address className="footer__group" aria-label="Contatos">
            <h3 className="footer__title">Contatos</h3>
            <ul className="footer__list">
              <li><a className="footer__link" href="https://www.google.com/maps/search/?api=1&query=Rua%20Maria%20F.%20de%20Souza%20Melo%2C%2055%2C%20S%C3%A3o%20Jo%C3%A3o%2C%20Conselheiro%20Lafaiete%2C%20MG" target="_blank" rel="noopener noreferrer">Rua Maria F. de Souza Melo, 55, São João, Conselheiro Lafaiete/MG</a></li>
              <li><a className="footer__link" href="tel:+5531990870412">(31) 99087-0412</a></li>
              <li><a className="footer__link" href="mailto:contato@vitalink.com.br">contato@vitalink.com.br</a></li>
            </ul>
          </address>

          <section className="footer__group" aria-label="Redes sociais">
            <h3 className="footer__title">Redes sociais</h3>
            <div className="footer__social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://instagram.com/vitalinkcl" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            </div>
            <img src={anatel} alt="Selo de homologação Anatel" className="footer__anatel" loading="lazy" />
          </section>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <small>© 2026 VitaLink Internet LTDA - CNPJ 60.308.811/0001-86</small>
          <small>
            Desenvolvido por <a href="https://rayv.com.br" className="footer__link footer__link--strong">AMDL Desenvolvimento</a>
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
